var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraspSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9329 0.492893C15.9602 0.394964 15.2237 1.39601 11.9208 3.27117C6.44235 6.38676 5.08964 5.5453 3.02676 7.98627C-1.21925 12.8102 0.821081 17.5869 6.56259 19.8864C13.623 22.7445 21.48 19.0377 23.7608 11.4863C24.2155 9.82879 25.2112 6.20541 23.0093 3.30744C22.4231 2.5131 21.6659 1.85038 20.7898 1.36461C19.9136 0.878836 18.9391 0.581484 17.9329 0.492893Z",
    fill: "#ACACAC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraspSmall);
export default __webpack_public_path__ + "static/media/grasp_small.656c8299d123944294095194c1b0f8a0.svg";
export { ForwardRef as ReactComponent };